import React, { useEffect, useState } from "react";
import "./list_data_work_order.css";
import { Table, Input, Button, Space } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import type { TableColumnType } from "antd";
import axios from "axios";
interface WorkOrderDataType {
    id: string;
    key: React.Key;
    invoiceWorkOrderNo: string;
    invoiceDate: string;
    workOrderNo: string;
    customerName: string;
    warehouse: string;
}
const ListDataWorkOrder: React.FC<{ onSelect?: (record: WorkOrderDataType) => void }> = ({ onSelect }) => {
    const [dataSource, setDataSource] = useState<WorkOrderDataType[]>([]);
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/invoice-return/work-order-list`);
                setDataSource(res.data.map((item: any) => ({ ...item, key: item.id })));
            } catch (err) { console.error(err); }
            setLoading(false);
        };
        fetchData();
    }, []);
    const getColumnSearchProps = (dataIndex: keyof WorkOrderDataType): TableColumnType<WorkOrderDataType> => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
                <Input
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => confirm()}
                    style={{ marginBottom: 8, display: 'block' }}
                />
                <Space>
                    <Button type="primary" onClick={() => confirm()} icon={<SearchOutlined />} size="small" style={{ width: 90 }}>Search</Button>
                    <Button onClick={() => clearFilters && clearFilters()} size="small" style={{ width: 90 }}>Reset</Button>
                </Space>
            </div>
        ),
        filterIcon: (filtered: boolean) => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
        onFilter: (value, record) => record[dataIndex].toString().toLowerCase().includes((value as string).toLowerCase()),
    });
    const columns = [
        { title: 'Invoice Work Order No', dataIndex: 'invoiceWorkOrderNo', key: 'invoiceWorkOrderNo', sorter: (a: any, b: any) => a.invoiceWorkOrderNo.localeCompare(b.invoiceWorkOrderNo), ...getColumnSearchProps('invoiceWorkOrderNo') },
        { title: 'Invoice Date', dataIndex: 'invoiceDate', key: 'invoiceDate', sorter: (a: any, b: any) => a.invoiceDate.localeCompare(b.invoiceDate), ...getColumnSearchProps('invoiceDate') },
        { title: 'Work Order No', dataIndex: 'workOrderNo', key: 'workOrderNo', sorter: (a: any, b: any) => a.workOrderNo.localeCompare(b.workOrderNo), ...getColumnSearchProps('workOrderNo') },
        { title: 'Customer Name', dataIndex: 'customerName', key: 'customerName', sorter: (a: any, b: any) => a.customerName.localeCompare(b.customerName), ...getColumnSearchProps('customerName') },
        { title: 'Warehouse', dataIndex: 'warehouse', key: 'warehouse', sorter: (a: any, b: any) => a.warehouse.localeCompare(b.warehouse), ...getColumnSearchProps('warehouse') },
    ];
    const transformStyle = {
        transform: "scale(0.80)",
        transformOrigin: "top left",
        width: "125%",
    };
    return (
        <div id="is4l" style={transformStyle}>
            <div className="gjs-grid-row" id="irzof">
                <div className="gjs-grid-column" id="i20fo">
                    <Table columns={columns}
                        dataSource={dataSource}
                        loading={loading}
                        bordered size="small"
                        onRow={(record) => ({
                            onClick: () => onSelect?.(record),
                            style: { cursor: 'pointer' }
                        })}
                    />
                </div>
            </div>
        </div>
    );
};
export default ListDataWorkOrder;